import { StaticLocationParamaters, } from "cg-foundation-theming";
var SolutionGroupComponentController = (function () {
    function SolutionGroupComponentController(locationService) {
        this.locationService = locationService;
    }
    SolutionGroupComponentController.prototype.getSolutionUrl = function (groupKey) {
        var thirdPartyProductsParameter = StaticLocationParamaters.thirdPartyProducts;
        var thirdPartyProducts = this.locationService.get(thirdPartyProductsParameter, true);
        var filtersParameter = StaticLocationParamaters.filters;
        var filters = this.locationService.get(filtersParameter);
        return this.locationService.build("compatibilityguide/solutions", {
            products: [groupKey],
            thirdPartyProducts: thirdPartyProducts,
            filters: filters,
        });
    };
    SolutionGroupComponentController.$inject = ["locationService"];
    return SolutionGroupComponentController;
}());
export var SolutionGroupComponent = {
    bindings: {
        group: "<",
        thirdPartyDevices: "<",
    },
    controller: SolutionGroupComponentController,
    templateUrl: "compatibilityguide/ng-templates/feature/search/solutiongroup",
};
